@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="types()"
    [label]="'entity.timesheet-types' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />

} @else {

  <elcia-dropdown
    [control]="control()"
    [items]="types()"
    [label]="'entity.timesheet-type' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />

}
